<script lang="ts">
  // Static footer component - no props needed
</script>

<footer class="w-full py-8 mt-12 border-t border-[#f0f2f4] bg-white">
  <div class="layout-container flex justify-center w-full px-10">
    <div class="max-w-[1280px] w-full flex flex-col md:flex-row justify-between items-center gap-4">
      <p class="text-[#617589] text-sm">&copy; 2026 EazyCalculators. All rights reserved.</p>
      <div class="flex gap-6">
        <a class="text-[#617589] text-sm hover:text-[#111418]" href="/privacy-policy">Privacy Policy</a>
        <a class="text-[#617589] text-sm hover:text-[#111418]" href="/terms-of-service">Terms of Service</a>
        <a class="text-[#617589] text-sm hover:text-[#111418]" href="/sitemap.xml" target="_blank" rel="noopener">Sitemap</a>
<!--        <a class="text-[#617589] text-sm hover:text-[#111418]" href="#">Contact Support</a>-->
      </div>
    </div>
  </div>
</footer>
